export default "<div [id]=\"chartId\" style=\"width: 100%\"></div>\r\n"